<template>
  <!-- 敬在的观点与优势 -->
  <div>
    <pageNav :currentActiveNav="'敬在的观点与优势'" v-if="isMobile"></pageNav>
    <pageHeader></pageHeader>
    <div class="content">
      <pageNav :currentActiveNav="'敬在的观点与优势'" v-if="!isMobile"></pageNav>
      <div class="tab-box">
        <div class="tab">
          <div class="tab-item" v-for="(item, index) in config.tabList" :key="index">
            <div class="tab-item-title" :class="{ active: activeTab == item.name }" @click="clickTab(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="tab-info">
          <div class="tab-info-top">
            <div class="tab-info-title">
              {{ config.tabInfo[activeTab].title }}
            </div>
            <div class="tab-info-desc" v-if="config.tabInfo[activeTab].desc">
              {{ config.tabInfo[activeTab].desc }}
            </div>
          </div>

          <div v-if="activeTab == '观点与优势一' || activeTab == '观点与优势二'">
            <div class="tab-info-content" v-for="(element, index) in config.tabInfo[activeTab].tabContent" :key="index"
              :class="{
                'tab-info-content-active':
                  activeTab == '观点与优势二' && element.fold,
              }">
              <!-- 优势1 -->
              <div class="content-one" v-if="activeTab == '观点与优势一'">
                <div class="tab-info-content-left">
                  <div class="left-info">{{ element.info }}</div>
                  <span class="left-des">{{ element.des }}</span>
                </div>
                <el-image :src="element.src" :key="element.src"></el-image>
              </div>
              <!-- 优势2 -->
              <div v-if="activeTab == '观点与优势二'">
                <div class="content-two-top">
                  <div class="content-two-name">{{ element.name }}</div>
                  <div class="fold-btn" @click="clickFold(element)">
                    <i v-if="element.fold" class="el-icon-minus"></i>
                    <i v-else class="el-icon-plus"></i>
                  </div>
                </div>
                <div class="content-two-img" v-if="element.fold">
                  <div class="content-two-img-item" v-for="(img, idx) in element.imgList" :key="idx + 'img'">
                    <el-image :src="img.src" :key="img.src"></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 优势3 -->
          <div class="system-content" v-if="activeTab == '观点与优势三'">
            <div v-for="(system, systemIndex) in config.tabInfo[activeTab]
              .tabContent" :key="systemIndex" class="system-item">
              <div class="system-item-title">{{ system.num }}</div>
              <div class="system-item-info">{{ system.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "./js/viewpoints_advantages";
import pageHeader from "./components/header.vue";
import pageNav from "./components/navMenu.vue";

export default {
  name: "",
  components: { pageHeader, pageNav },
  data() {
    return {
      config: config,
      activeTab: "观点与优势一",
    };
  },
  watch: {},
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    }
  },
  mounted() {
    const routeParams = this.$route.query;
    switch (routeParams.activeTab) {
      case '0':
        this.activeTab = '观点与优势一'
        break
      case '1':
        this.activeTab = '观点与优势二'
        break
      case '2':
        this.activeTab = '观点与优势三'
        break
    }
  },
  methods: {
    clickTab(item) {
      this.activeTab = item.name;
      this.config.tabInfo[this.activeTab].tabContent.forEach(
        (element, index) => {
          if (index == 0) {
            element.fold = true;
          } else {
            element.fold = false;
          }
        }
      );
    },
    clickFold(item) {
      this.config.tabInfo[this.activeTab].tabContent.forEach((element) => {
        if (item.name == element.name) {
          element.fold = !element.fold;
        } else {
          element.fold = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.content {
  padding: 45px 68px 100px;

  .tab-box {
    margin: 0 217px;

    .tab {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      font-size: 20px;

      .tab-item {
        text-align: center;
        cursor: pointer;

        .tab-item-title {
          padding: 17px 0;
        }
      }

      .active {
        border-bottom: 6px solid @mainColor;
        font-weight: 600;
      }
    }

    .tab-info {
      .tab-info-top {
        margin-bottom: 60px;

        .tab-info-title {
          font-size: 40px;
          padding: 60px 0 0;
          line-height: 60px;
        }

        .tab-info-desc {
          margin-top: 20px;
          font-size: 20px;
        }
      }

      .tab-info-content-active {
        border-left: 6px solid @mainColor;
      }

      .tab-info-content {
        padding: 40px 38px;
        border-top: 1px solid @mainGrayColor3;

        &:last-child {
          border-bottom: 1px solid @mainGrayColor3;
        }

        .tab-info-content-left {
          .left-info {
            font-size: 20px;
            line-height: 40px;
            margin-bottom: 20px;
          }

          .left-des {
            font-size: 20px;
            padding: 5px 15px;
            background: @mainColor;
          }
        }

        .content-one {
          display: grid;
          grid-template-columns: 4fr 1fr;
          grid-column-gap: 20px;
        }

        .content-two-top {
          display: flex;
          justify-content: space-between;

          .fold-btn {
            cursor: pointer;
            font-size: 20px;
          }

          .content-two-name {
            font-size: 20px;
          }
        }

        .content-two-img {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-column-gap: 40px;
          margin-top: 32px;
        }

        .content-two-des {
          font-size: 20px;
          padding: 5px 15px;
          background: @mainColor;
        }

        .content-two-bottom {
          display: flex;
          justify-content: space-between;
          margin-bottom: 32px;

          .content-two-name {
            font-size: 20px;
          }
        }
      }
    }
  }

  .system-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 24px;

    .system-item {
      padding: 30px 0px 0px;
      border-top: 1px solid @mainGrayColor3;

      &:nth-last-child(2),
      &:last-child {
        border-bottom: 1px solid @mainGrayColor3;
      }

      .system-item-title {
        font-size: 40px;
        position: relative;
        width: fit-content;
        cursor: pointer;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .system-item-info {
        font-size: 20px;
        line-height: 32px;
        margin: 20px 0 51px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }
  }
}

@media @mobile {
  .content {
    padding: 20px 16px 60px;

    .tab-box {
      margin: 0;

      .tab {
        grid-template-columns: 1fr 1fr 1fr;
        font-size: 16px;

        .tab-item {
          .tab-item-title {
            padding: 12px 0;
            border-bottom: 1px solid @mainGrayColor3;
          }

          .active {
            border-bottom: 3px solid @mainColor;
            font-weight: 600;
          }
        }
      }

      .tab-info {
        .tab-info-top {
          margin-bottom: 30px;

          .tab-info-title {
            font-size: 20px;
            padding: 30px 0 0;
            line-height: 1.4;
          }

          .tab-info-desc {
            margin-top: 16px;
            font-size: 12px;
            line-height: 1.5;
            color: #6E6D6F;
          }
        }

        .tab-info-content-active {
          border-left: 3px solid @mainColor;
        }

        .tab-info-content {
          padding: 20px 16px;

          .tab-info-content-left {
            .left-info {
              font-size: 16px;
              line-height: 24px;
              margin-bottom: 16px;
            }

            .left-des {
              font-size: 14px;
              padding: 4px 12px;
            }
          }

          .content-one {
            grid-template-columns: 1fr;
            grid-column-gap: 0;
            grid-row-gap: 16px;

            img {
              width: 100%;
              height: auto;
              object-fit: cover;
            }
          }

          .content-two-top {
            .fold-btn {
              font-size: 16px;
            }

            .content-two-name {
              font-size: 16px;
            }
          }

          .content-two-img {
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 16px;
            grid-row-gap: 16px;
            margin-top: 20px;

            img {
              width: 100%;
              height: auto;
              object-fit: cover;
            }
          }

          .content-two-des {
            font-size: 14px;
            padding: 4px 12px;
          }

          .content-two-bottom {
            margin-bottom: 20px;

            .content-two-name {
              font-size: 16px;
            }
          }
        }
      }
    }

    .system-content {
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 0;
      grid-row-gap: 20px;

      .system-item {
        padding: 20px 0 0;

        &:nth-last-child(2),
        &:last-child {
          border-bottom: 1px solid @mainGrayColor3;
        }

        .system-item-title {
          font-size: 24px;
          line-height: 1.4;
          -webkit-line-clamp: 2;
          height: auto;
        }

        .system-item-info {
          font-size: 16px;
          line-height: 24px;
          margin: 16px 0 30px;
          -webkit-line-clamp: 3;
        }
      }
    }
  }
}
</style>
